import React, { useState } from "react";
import PropTypes from "prop-types";

import { Label, Input } from "./styles";

const Checkbox = ({ label, onClick, initialValue, isDisabled }) => {
    const [isChecked, toggleCheck] = useState(initialValue);

    return (
        <Label isDisabled={isDisabled}>
            <Input
                isDisabled={isDisabled}
                isChecked={isChecked}
                type="checkbox"
                value={label}
                defaultChecked={isChecked}
                aria-disabled={isDisabled}
                onClick={() => {
                    if (isDisabled) return;
                    toggleCheck(!isChecked);
                    onClick(!isChecked);
                }}
            />
            <span>{label}</span>
        </Label>
    );
};

Checkbox.propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    initialValue: PropTypes.bool.isRequired,
    isDisabled: PropTypes.bool.isRequired
};

export default Checkbox;
